import CryptoJS from 'crypto-js'

export const isNull = (value: any) => {
	if (typeof value === 'undefined' || value === null) {
		return true
	}
	if (typeof value === 'object' || typeof value === 'function') {
		return false
	}
	const isEmptyString = typeof value === 'string' && value === ''
	const isNotANumber =
		typeof value === 'number' &&
		(Number.isNaN(value) || !Number.isFinite(value))
	return isEmptyString || isNotANumber
}

export const isNotNull = (value: any) => !isNull(value)
/**
 * AES加密
 * @param {string} str 加密数据
 */
export const cryptoEncrypt = (str: string) => {
	const IV = '8NONwyJtHesysWpM' //固定值
	const KEY = '1234567898882223' //16位
	const key = CryptoJS.enc.Utf8.parse(KEY)
	const iv = CryptoJS.enc.Utf8.parse(IV)
	const encrypted = CryptoJS.AES.encrypt(str, key, {
		iv: iv,
		mode: CryptoJS.mode.CBC,
		padding: CryptoJS.pad.Pkcs7,
	})

	return encrypted.toString()
}

export const transformBidType = (data: any) => {
	if (data.bid_type === 2) {
		if (data.main_body === 2) {
			return 7
		}
		if (data.main_body === 3) {
			return 8
		}
		return 2
	}
	return data.bid_type
}
